import { useState, useEffect } from "react";
import Sider from "../../components/siderbarcomponents";
import PriceUpdate from "../../components/PriceUpsate";
import { subscribeToPrecios } from "../../firebase/firebaseService";

export default function DashboardEmpresa() {
  const [precios, setPrecios] = useState<any[]>([]);

  useEffect(() => {
    const unsubscribe = subscribeToPrecios((data) => {
      setPrecios(data);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="flex-col lg:flex-row flex min-h-screen bg-slate-50">
      <Sider />
      <div className="flex-1 overflow-auto">
        <PriceUpdate precios={precios} />
      </div>
    </div>
  );
}
